<template>
    <footer class="footer-footer section-container">
        <div class="footer-max-width max-content-container">
            <div class="footer-banner">
                <h1 class="footer-text heading2">{{ lineStayInTouch }}</h1>
                <div class="footer-btns-container">
                    <a
                            :href="`mailto:${email}`"
                            rel="noreferrer noopener"
                            class="footer-contact-us button button-outline button-lg-border"
                    >
                        {{ lineContactUs }}
                    </a>
                </div>
            </div>
            <footer class="footer-footer1">
                <api-image
                        :image="logo"
                        :title="title"
                        class="footer-image"
                />
                <span class="footer-text1">{{ copyright }}</span>
                <div class="footer-icon-group">
                    <a v-for="item of socials" :href="item.Link">
                        <api-image
                                :image="item.Icon" :title="item.Name" class="icon-group-icon"/>
                    </a>
                </div>
            </footer>
        </div>
    </footer>
</template>

<script>
    import api_fetch from "../api_fetch";

    export default {
        data() {
            return {
                email: null,
                copyright: null,
                socials: [],
                logo: null,
                title: null,
                lineStayInTouch: null,
                lineContactUs: null
            }
        },
        created() {
            api_fetch('api/App').then((data) => {
                this.email = data.attributes.ContactEmail;
                this.copyright = data.attributes.Copyright;
                this.logo = data.attributes.Logo;
                this.title = data.attributes.Title;
                this.lineStayInTouch = data.attributes.LineStayInTouch;
                this.lineContactUs = data.attributes.LineContactUs;
            });

            api_fetch('api/socials').then((data) => {
                data.forEach(item => {
                    this.socials.push(item.attributes);
                });
            });
        }
    }
</script>

<style scoped>
    .footer-footer {
        z-index: 100;
        padding-top: var(--dl-space-space-sixunits);
        border-color: var(--dl-color-scheme-white);
        border-width: 0px;
        padding-bottom: var(--dl-space-space-unit);
        background-size: contain;
        background-image: url("/playground_assets/os-bottom-1500w.png");
        border-top-width: 0px;
        background-repeat: no-repeat;
        border-left-width: 0px;
        border-right-width: 0px;
        background-position: bottom right;
        border-bottom-width: 0px;
    }

    .footer-max-width {
        align-items: flex-start;
        flex-direction: column;
        justify-content: space-between;
    }

    .footer-banner {
        flex: 0 0 auto;
        width: 100%;
        display: flex;
        margin-top: -15%;
        align-items: center;
        padding-top: 56px;
        padding-left: var(--dl-space-space-oneandhalfunits);
        margin-bottom: 91px;
        padding-right: var(--dl-space-space-oneandhalfunits);
        flex-direction: column;
        padding-bottom: 70px;
        background-size: cover;
        background-image: url("/playground_assets/os-background-contact.png");
    }

    .footer-text {
        color: var(--dl-color-scheme-white);
        text-align: center;
        margin-bottom: var(--dl-space-space-halfunit);
    }

    .footer-btns-container {
        flex: 0 0 auto;
        display: flex;
        margin-top: var(--dl-space-space-twounits);
        align-items: flex-start;
    }

    .footer-contact-us {
        color: var(--dl-color-scheme-white);
        border-color: var(--dl-color-scheme-white);
        text-decoration: none;
    }

    .footer-contact-us:hover {
        color: var(--dl-color-scheme-white);
        border-color: var(--dl-color-scheme-pink);
        background-color: var(--dl-color-scheme-pink);
    }

    .footer-footer1 {
        width: 100%;
        display: flex;
        max-width: var(--dl-size-size-maxwidth);
        align-items: center;
        padding-top: var(--dl-space-space-twounits);
        padding-left: var(--dl-space-space-threeunits);
        padding-right: var(--dl-space-space-threeunits);
        padding-bottom: var(--dl-space-space-twounits);
        justify-content: space-between;
    }

    .footer-image {
        height: var(--dl-size-size-medium);
        object-fit: cover;
    }

    .footer-icon-group {
        display: flex;
        align-items: center;
        flex-direction: row;
        justify-content: space-between;
    }

    .icon-group-icon {
        width: 24px;
        height: 24px;
        object-fit: cover;
        filter: brightness(0) invert(1);
        margin: 0 12px;
    }

    .footer-icon {
        fill: var(--dl-color-scheme-pink);
        width: var(--dl-size-size-xsmall);
        height: var(--dl-size-size-xsmall);
        margin-right: var(--dl-space-space-twounits);
    }

    @media (max-width: 767px) {
        .footer-btns-container {
            width: 100%;
            justify-content: center;
        }

        .footer-footer1 {
            padding-left: var(--dl-space-space-twounits);
            padding-right: var(--dl-space-space-twounits);
        }

        .footer-text1 {
            text-align: center;
            margin-left: var(--dl-space-space-unit);
            margin-right: var(--dl-space-space-unit);
        }
    }

    @media (max-width: 479px) {
        .footer-btns-container {
            align-items: stretch;
            flex-direction: column;
        }

        .footer-footer1 {
            padding: var(--dl-space-space-unit);
            flex-direction: column;
        }

        .footer-image {
            margin-bottom: var(--dl-space-space-unit);
        }

        .footer-text1 {
            margin-left: 0px;
            margin-right: 0px;
            margin-bottom: var(--dl-space-space-unit);
        }
    }
</style>
